
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('FORUM_LAST_TOPICS').plugin(axiosPlugin, {template: "array"});

let fetchLastTopicsAction = redux.fetchActionGet();

export const fetchForumLastTopics = () => fetchLastTopicsAction(`/topics/last`);
export const resetForumLastTopics = () => redux.actions.reset();

export const forumLastTopics = redux.reducer();